<template>
    <v-dialog persistent v-model="get_dialogSecoundMain.dialog" width="95%" justify-center>
        <v-toolbar dense dark color="blue darken-2">
            <v-toolbar-title>
                <h3>Importar  Informacion </h3>
            </v-toolbar-title>
        <v-spacer></v-spacer>
            <v-btn icon dark @click="HIDDE_DIALOG_SECOUND_MAIN()">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-card width="auto" tile>
            <v-form ref="form">
                <v-card-text>
                  <v-row>
                    <v-col cols="4">
                      <v-btn color="info" dark text @click="objectsExport(1)">Layouts Fomato 1</v-btn>
                      <v-btn color="info" dark text @click="objectsExport(2)">Layouts Fomato 2</v-btn>
                    </v-col>
                  </v-row>
                    <ImportData :on-success="handleSuccess" :before-upload="beforeUpload"/>
                    <div class="pa-5" v-if="upload">
                      <h2 class="text-center">Registro enviados {{ porcentaje }} %</h2>
                      <v-progress-linear
                        indeterminate
                        color="light-blue"
                        height="5"
                        striped />
                        <p class="font-weight-bold text-center">Subiendo Informacion de Personas</p>
                    </div>
                    <DataTableMain v-if="tableHeader.length > 0" :datatable="table" :on-success="successAction" :itemsAction="tableAction"/>
                </v-card-text>
                <v-card-actions>
                    <v-layout justify-end>
                    <v-btn class="red darken-1 mr-3" dark @click="cancel">Cancelar</v-btn>
                    <v-btn class="green darken-1 mr-3" dark @click="saveImport"> Importar</v-btn>
                    </v-layout>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMain'
import ImportData from '@/components/ImportData'
import XLSX from 'xlsx'
export default {
  data: () => ({
    table: {
      header: {
        options: [],
        titles: [
          { text: 'Id', value: 'id', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: []
      },
      footer: {
        paging: true
      }
    },
    tableData: [],
    tableHeader: [],
    urlAction: 'person.importar',
    upload: false,
    dowload1: [
      {
        DF: '2',
        DL: '6',
        MUNICIPIO: 'TIMUCUY',
        SECCION: '899',
        'APELLIDO PATERNO': 'FERNANDEZ',
        'APELLIDO MATERNO': 'KU',
        NOMBRE: 'ALEJANDRO',
        'FECHA NACIMIENTO': '9/7/1975',
        INE: 'FRTZED75070931H301',
        CURP: 'FOTB750709HYGRZR02',
        CALLE: '3',
        NUMERO: 'S/N',
        CRUZAMIENTO: '2',
        'CRUZAMIENTO 2': '3 A',
        COLONIA: 'LOC SUBINCANCAB',
        CP: '97377',
        'EMPLEADO ESTATAL': 'NO',
        'EMPLEADO ESTATAL DESCENTRALIZADO': 'NO',
        'EMPLEADO AYUNTAMIENTO DE MÉRIDA': 'SI',
        'EMPLEADO AYUNTAMIENTO, INTERIOR DEL ESTADO': 'NO'
      }
    ],
    dowload2: [
      {
        'DISTRITO FEDERAL': '2',
        'DISTRITO LOCAL': '6',
        MUNICIPIO: '41',
        'NOMBRE MUNICIPIO': 'KANASIN',
        SECCION: '212',
        'NOMBRE COMPLETO': 'PECH KU FERNANDO ENRIQUE',
        'CLAVE ELECTOR': 'FGCHGS84031731H300',
        'FECHA NACIMIENTO': '17/3/1998',
        SEXO: 'H',
        CALLES: 'C 42 B POR 58 Y 60',
        NUMERO: '557 C',
        COLONIA: 'FRACC REPARTO GRANJAS',
        'CODIGO POSTAL': '97000',
        TELEFONO: '9999789123',
        MOVIL: '9999123456',
        CORREO: 'example@example.com'
      }
    ],
    porcentaje: 0,
    cantidad: 5000,
    current: 0,
    pages: 0
  }),
  components: {
    ImportData,
    DataTableMain
  },
  methods: {
    ...mapActions(['getUrlServices', 'postUrlServicesAction']),
    successAction (item) {
      this[item.action](item)
    },
    tableAction (item) {
      this[item.action](item)
    },
    /* ---------- ---------- ---------- ---------- */
    saveImport () {
      if (this.get_urls != null) {
        if (this.tableData.length > 0) {
          const cantidad = (this.tableData.length > this.cantidad) ? this.cantidad : this.tableData.length
          this.upload = true
          const PeronPage = this.tableData.splice(0, cantidad)
          // console.log('PeronPage', PeronPage)
          // console.log('tableData', this.tableData)
          this.current += cantidad
          this.porcentaje = this.decimalAdjust('round', ((this.current / (this.tableData.length + this.current)) * 100), -1)
          const router = this.get_urls[this.urlAction]
          this.postUrlServicesAction({ url: router, data: { header: this.tableHeader, data: PeronPage } })
        } else {
          this.$swal({
            type: 'warning',
            icon: 'warning',
            title: 'Advertencia!',
            text: 'Para importar los datos debe cargar un archivo Excel.'
          })
        }
      } else {
        this.getUrlServices()
      }
    },
    cancel () {
      this.HIDDE_DIALOG_SECOUND_MAIN()
    },

    beforeUpload (file) {
      const isLt1M = file.size / 1024 / 1024 < 20
      if (isLt1M) {
        return true
      }
      console.log({
        message: isLt1M + ' --Please do not upload files larger than 1m in size.',
        type: 'warning'
      })
      return false
    },
    handleSuccess ({ results, header }) {
      this.tableData = results
      this.tableHeader = header
      this.table.header.titles = header.map((item) => {
        return { text: item, value: item, class: 'black--text' }
      })
      this.table.body.data = results
    },
    objectsExport (vals) {
      const dataExample = (vals === 1) ? this.dowload1 : this.dowload2
      const format = (vals === 1) ? 'Formato1' : 'Formato2'
      const data = XLSX.utils.json_to_sheet(dataExample)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, data, format)
      XLSX.writeFile(workbook, `${format}.xlsx`)
    },
    decimalAdjust (type, value, exp) {
      // Si el exp no está definido o es cero...
      if (typeof exp === 'undefined' || +exp === 0) {
        return Math[type](value)
      }
      value = +value
      exp = +exp
      // Si el valor no es un número o el exp no es un entero...
      if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
        return NaN
      }
      // Shift
      value = value.toString().split('e')
      value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)))
      // Shift back
      value = value.toString().split('e')
      return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp))
    },
    ...mapMutations(['HIDDE_DIALOG_SECOUND_MAIN'])

  },
  computed: {
    ...mapGetters(['get_dialogSecoundMain', 'get_urls', 'get_object'])
  },
  watch: {
    get_object (val) {
      if (val) {
        if (val.message) {
          this.$swal({
            type: 'error',
            icon: 'error',
            title: 'Error!',
            text: val.message
          })
        }
        if (this.porcentaje < 100) {
          setTimeout(() => {
            this.saveImport()
          }, 3000)
        } else {
          this.upload = false
          this.$swal({
            type: 'success',
            icon: 'success',
            title: 'Exitoso!',
            text: 'La informacion de personas se subio correctamente'
          })
        }
      }
    },
    get_urls (vals) {
      this.saveImport()
    }
  }
}
</script>

<style>
</style>
